import { twMerge } from '@/lib/classname/twMerge'
import type { PropsWithChildren } from 'react'

export type BaseSkeletonProps = PropsWithChildren<{
  id?: string
  className?: string
}>

export function BaseSkeleton({ children, id, className }: BaseSkeletonProps) {
  return (
    <div
      id={id}
      aria-hidden
      className={twMerge(
        'rounded-sm',
        className,
        'min-w-1 animate-skeleton select-none bg-[--skeleton-bg-color]',
      )}
    >
      {children ?? <>&nbsp;</>}
    </div>
  )
}
